import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";

import {
  View,
  ScrollView,
  Heading,
  Text,
  Pressable,
  Box,
  VStack,
  Center,
} from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";

const ChemicalPlatform = ({
  navigation,
}: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  return (
    <ImageBackground
      source={require("../../assets/bubles.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView px={10}>
            <Header
              onPress={() => navigation.navigate("Production")}
              parentText="Production"
              headingText="Industrial Plant"
              // intro="In partnership with NSIA, OCP is developing a $1.4 billion industrial plant in Ikot Abasi, Akwa Ibom State. This industrial plant will produce DAP (1MMT) & Ammonia(750KT) locally in phase 1 and will create over 7,500 jobs (Production & Construction). This will generate over a $400 Million trade surplus against a $500 million trade deficit. This project will not just secure significant goodwill from Nigeria government but will utilize gas from Nigeria and Phosphate from Morocco to make Nigeria self-sufficient in fertilizer production. This industrial plant will serve as source of Nitrogen to Morocco & Phosphate to Nigeria and share resources between both countries to make Nigeria the preferred source of phosphate-based fertilizer to west Africa neighbors."
            />

            <Text textAlign={"center"} alignSelf="center" mb={4}>
              In partnership with NSIA, OCP is developing a $1.4 billion
              industrial plant in Ikot Abasi, Akwa Ibom State. This industrial
              plant will produce DAP (1MMT) & Ammonia(750KT) locally in phase 1
              and will create over 7,500 jobs (Production & Construction). This
              will generate over a $400 Million trade surplus against a $500
              million trade deficit. This project will not just secure
              significant goodwill from Nigeria government but will utilize gas
              from Nigeria and Phosphate from Morocco to make Nigeria
              self-sufficient in fertilizer production. This industrial plant
              will serve as source of Nitrogen to Morocco & Phosphate to Nigeria
              and share resources between both countries to make Nigeria the
              preferred source of phosphate-based fertilizer to west Africa
              neighbors.
            </Text>

            <Box w={320} h={350} margin="auto" mt={5}>
              <ImageBackground
                source={require("../../assets/industrial_plant.png")}
                style={{
                  width: 320,
                  height: 350,
                  borderRadius: 35,
                  overflow: "hidden",
                  borderWidth: 5,
                  borderColor: "white",
                }}
                imageStyle={{
                  borderRadius: 15,
                  backgroundColor: "rgba(0,0,0,.8)",
                }}
              >
                <Center style={styles.cardOverlay}>
                  {/* <Image
                    source={require("../../assets/playicon.png")}
                    style={{ height: 40, width: 40 }}
                  /> */}

                  <iframe
                    src="https://www.youtube.com/embed/aW7PeGMwbHM"
                    title="Industrial Plant 3D Video"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 15,
                      overflow: "hidden",
                      borderWidth: 2,
                      borderColor: "white",
                    }}
                    // frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    // allowfullscreen
                  ></iframe>
                </Center>
              </ImageBackground>
            </Box>

            <View style={{ height: 20 }}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default ChemicalPlatform;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#540114e6",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});
